export const steps = [
  { title: 'inventory_counts_step_1_title', description: 'inventory_counts_step_1_description' },
  { title: 'inventory_counts_step_2_title', description: 'inventory_counts_step_2_description' },
  { title: 'inventory_counts_step_3_title', description: 'inventory_counts_step_3_description' },
  { title: 'inventory_counts_step_4_title', description: 'inventory_counts_step_4_description' },
];
